module.exports = __webpack_public_path__ + "img/novoeight_icon.1f6166ab.svg";